import { StepContainer, Step } from "newui/components/Stepper";
import { EVALUATION_STEP_META } from "../../constants/evaluation.constants";
import { EvaluationCriteriaStep } from "../steps/EvaluationCriteriaStep";
import { InitialEvaluationStep } from "../steps/InitialEvaluationStep";
import { ClarificationsStep } from "../steps/ClarificationsStep";
import { RevisionsStep } from "../steps/RevisionsStep";
import { FinalEvaluationStep } from "../steps/FinalEvaluationStep";
import type { EvaluationState } from "../../types/evaluation.type";

interface RFxEvaluationStepsProps {
	rfxId: number;
	rfxSubmissionId?: number;
	evaluationState: EvaluationState | null;
	onComplete?: () => void;
}

const getStepEnabled = (
	stepIndex: number,
	evaluationState: EvaluationState | null
): boolean => {
	// First step is always enabled
	if (stepIndex === 0) {
		return true;
	}

	if (!evaluationState) {
		return false;
	}

	// A step is enabled if the previous step is completed
	const previousStep = evaluationState.steps[stepIndex - 1];
	return previousStep?.status === "completed";
};

export const RFxEvaluationSteps: React.FC<RFxEvaluationStepsProps> = ({
	rfxId,
	rfxSubmissionId,
	evaluationState,
	onComplete,
}) => {
	const initialStep = evaluationState?.currentStep ?? 0;

	return (
		<StepContainer
			initialStep={initialStep}
			onComplete={onComplete}
		>
			<Step
				name={EVALUATION_STEP_META[0].name}
				description={EVALUATION_STEP_META[0].description}
				enabled={getStepEnabled(0, evaluationState)}
				info={EVALUATION_STEP_META[0].info}
			>
				<EvaluationCriteriaStep
					rfxId={rfxId}
					rfxSubmissionId={rfxSubmissionId}
				/>
			</Step>
			<Step
				name={EVALUATION_STEP_META[1].name}
				description={EVALUATION_STEP_META[1].description}
				enabled={getStepEnabled(1, evaluationState)}
				info={EVALUATION_STEP_META[1].info}
			>
				<InitialEvaluationStep
					rfxId={rfxId}
					rfxSubmissionId={rfxSubmissionId}
				/>
			</Step>
			<Step
				name={EVALUATION_STEP_META[2].name}
				description={EVALUATION_STEP_META[2].description}
				enabled={getStepEnabled(2, evaluationState)}
				info={EVALUATION_STEP_META[2].info}
			>
				<ClarificationsStep
					rfxId={rfxId}
					rfxSubmissionId={rfxSubmissionId}
				/>
			</Step>
			<Step
				name={EVALUATION_STEP_META[3].name}
				description={EVALUATION_STEP_META[3].description}
				enabled={getStepEnabled(3, evaluationState)}
				info={EVALUATION_STEP_META[3].info}
			>
				<RevisionsStep
					rfxId={rfxId}
					rfxSubmissionId={rfxSubmissionId}
				/>
			</Step>
			<Step
				name={EVALUATION_STEP_META[4].name}
				description={EVALUATION_STEP_META[4].description}
				enabled={getStepEnabled(4, evaluationState)}
				info={EVALUATION_STEP_META[4].info}
			>
				<FinalEvaluationStep
					rfxId={rfxId}
					rfxSubmissionId={rfxSubmissionId}
				/>
			</Step>
		</StepContainer>
	);
};
